import { StepperSelectionEvent } from "@angular/cdk/stepper";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators, AbstractControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatStepper } from "@angular/material/stepper";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { validationmethod } from "src/app/shared/common/validationmethod";
import { DeviationService } from "src/app/shared/services/deviation.service";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";

export interface checkinListDialogData {
  uniqueRecordId: any;
  deviationFor: any;
  deviationId?: any; // 🔑 ONLY ID for edit // optional used in edit mode
  headerContext?:any;

  productName?: string;
  productId?: string;
}

interface MandatoryRule {
  control?: () => AbstractControl | null;
  label: string;
  controlName?: string; // the name used in template
  when?: () => boolean; // optional condition
  customCheck?: () => boolean;
}

interface HeaderContextItem {
  label: string;
  value: string;
}


@Component({
    selector: "app-deviation",
    templateUrl: "./deviation.component.html",
    styleUrls: ["./deviation.component.scss"],
    standalone: false
})
export class DeviationComponent implements OnInit {
  @ViewChild(MatStepper) stepper!: MatStepper;
  
  titleText = "Create Deviation";
  stepIndex = 0;
  backgroundColorButton = "";
  buttonColor = "";

  deviationForm: FormGroup;

  rootCauses: any[] = [];
  capas: any[] = [];

  deviationFor: any;
  uniqueRecordId: any;
  deviationType: any[] = [
    { id: 1, lookupvalue: "Manufacturing" },
    { id: 2, lookupvalue: "Product" },
    { id: 3, lookupvalue: "Validation" },
    { id: 4, lookupvalue: "Clinical" },
    { id: 5, lookupvalue: "Distribution" },
    { id: 6, lookupvalue: "Facilities " },
    { id: 7, lookupvalue: "Labelling" },
  ];
  owningFacility: any[] = [
    { id: 1, lookupvalue: "Facility A" },
    { id: 2, lookupvalue: "Facility B" },
    { id: 3, lookupvalue: "Facility C" },
  ];
  owningDepartment: any[] = [
    { id: 1, lookupvalue: "Department A" },
    { id: 2, lookupvalue: "Department B" },
    { id: 3, lookupvalue: "Department C" },
  ];
  deviationObjectType: any[] = [
    { id: 1, lookupvalue: " GCP deviation" },
    { id: 2, lookupvalue: "IT deviation" },
    { id: 3, lookupvalue: "Global deviation" },
  ];
  rating:any[]=[
    {id:1,lookupvalue:"Critical"},
    {id:2,lookupvalue:"Major"},
    {id:3,lookupvalue:"Minor"},
  ]

  isFormOpen = false;
  deviationId: string | null = null;
  private readonly ACTIVE_DEVIATION_ID = 'ACTIVE_DEVIATION_ID';
  loadRootCause = false;
  loadCapa = false;

  hasValidCapa = false;
  headerContext: HeaderContextItem[] = [];
  productName?: string;
  productId?: string;






  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<DeviationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: checkinListDialogData,
    private localStorageSettings: LocalStorageSettingsService,
    private jsignalsService: JsignalService,
    private deviationService: DeviationService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private validate: validationmethod,
  ) {}

  ngOnInit(): void {
    console.log("DATA RECEIVED IN DEVIATION DIALOG", this.data);

    this.deviationFor = this.data.deviationFor;
    this.uniqueRecordId = this.data.uniqueRecordId;

    console.log("Deviation For:", this.deviationFor);
    console.log("Unique Record ID:", this.uniqueRecordId);
    this.headerContext = this.data?.headerContext || [];

      // direct assignment
      this.productName = this.data.productName ?? null;
      this.productId = this.data.productId ?? null;

      this.headerContext = Array.isArray(this.data?.headerContext)
    ? this.data.headerContext
    : [];

  if (!this.validateHeaderContext(this.headerContext)) {
    this.handleFailure({
      message: 'Invalid header context received'
    });
    return;
  }

    this.createForm();

      //AUTO SELECT + DISABLE FOR GLOBAL DEVIATION
  if (this.deviationFor === 'Global Deviation') {

    const control = this.deviationForm.get('deviationObjectType');

    control?.setValue('Global deviation');
    control?.disable(); // makes it non-editable
  }

    if (this.data.deviationId) {
    // EDIT MODE
    this.titleText = 'Update Deviation';
    this.deviationId = this.data.deviationId;

    localStorage.setItem(this.ACTIVE_DEVIATION_ID, this.deviationId);
    this.loadDeviationForEdit(this.deviationId);
  } else {
    // CREATE MODE
    localStorage.removeItem(this.ACTIVE_DEVIATION_ID);
  }

  }

  //create form
createForm() {
  this.backgroundColorButton =  this.localStorageSettings.getSettings("ColorA");

  this.deviationForm = this.fb.group({
    deviationObjectType: ["", Validators.required], // TOP LEVEL

    deviationDetails: this.fb.group({
      title: ["", [Validators.required,this.validate.restrictAllSpecialCharactersExceptHyphenAndUnderscore]],
      description: ["", [Validators.required]],
      deviationType: ["", Validators.required],
      occurrenceDate: [null, Validators.required],
      awarenessDate: [null, Validators.required],
      correctiveAction: ["",this.validate.restrictAllSpecialCharactersExceptHyphenAndUnderscore],
      owningFacility: ["", Validators.required],
      owningDepartment: ["", Validators.required],
      rating:["",Validators.required],
      // impactAndRiskAnalysis:[""],
      // effectiveCheckDetails:[""],
      investigationAndSummaryConclusion:["",this.validate.restrictAllSpecialCharactersExceptHyphenAndUnderscore],

      furtherInvestigationRequired: [false],
      capaRequired: [false],
      effectiveCheckRequired: [false],
      externalTrackingId: [""],
    }, { updateOn: 'change' }) // <-- this ensures model updates immediately)
  });
}


saveDevaitionDetail(stepper: any) {

    // 1️. Make sure latest values are synced
  this.deviationForm.updateValueAndValidity({ onlySelf: false, emitEvent: true });

  // 2. Validate mandatory rules dynamically
  // if (!this.validateMandatoryRules()) {
  //   // If missing fields → stop and highlight them
  //   return;
  // }

  if (!this.deviationForm.valid) {
    this.deviationForm.markAllAsTouched();
    return;
  }

  const payload = this.buildPayload();
  console.log(payload);

  if (!localStorage.getItem(this.ACTIVE_DEVIATION_ID)) {
    // CREATE
    this.createDeviation(payload);
  } else {
    //UPDATE
    this.updateDeviation(localStorage.getItem(this.ACTIVE_DEVIATION_ID)!, payload);
  }
}

buildPayload() {
  const formValue = this.deviationForm.getRawValue();

  const payload = {
    deviationObjectType: formValue.deviationObjectType, // top-level
    deviationDetails: {
      ...formValue.deviationDetails,
      occurrenceDate: this.jsignalsService.toYYYYMMDD(
        formValue.deviationDetails.occurrenceDate
      ),
      awarenessDate: this.jsignalsService.toYYYYMMDD(
        formValue.deviationDetails.awarenessDate
      )
    },
    rootCauses: this.rootCauses,
    capas: this.capas
  };

  console.log("FINAL PAYLOAD", payload);
  return payload;
}


createDeviation(payload: any) {
   const dnsid =   this.localStorageSettings.getSettings("dnsName");
   const workspaceId = this.localStorageSettings.getSettings("WorkspaceId");

   const CreatePayload = {
    deviation: payload,
    metadata: this.buildMetadataFromHeaderContext(),

    //optional, explicit
    productName: this.productName,
    productId: this.productId
   };

   console.log(CreatePayload);

  this.spinner.start();

  this.deviationService.createDeviation(
  workspaceId,          
  dnsid,                
  this.deviationFor,    
  this.uniqueRecordId,  
  CreatePayload               
).subscribe({
    next: (res: any) => {
      this.spinner.stop();

      if (res.error) {
        this.handleFailure(res); //backend message shown
        return;
      }


      const deviationId = res?.data;

      if (!deviationId) {
        this.handleFailure();
        return;
      }

      this.handleSuccess(res);
      localStorage.setItem(this.ACTIVE_DEVIATION_ID, deviationId);
      this.deviationId = deviationId;
      this.loadRootCause = true;
      this.stepper.next();
    },
    error: () => this.handleFailure()
  });
}

updateDeviation(deviationId: string, payload: any) {
  this.spinner.start();

  this.deviationService.updateDeviation(deviationId, payload).subscribe({
    next: (res) => {
      this.spinner.stop();

      if (res.error) {
        this.handleFailure(res); //backend message shown
        return;
      }

      this.handleSuccess(res);
      this.loadRootCause = true;
      this.stepper.next();
    },
    error: (res) => this.handleFailure(res)
  });
}

next() {
  this.loadCapa = true;
  this.stepper.next();
}


closeDeviation(){

    if (!this.validateMandatoryRules()) {
    return;
  }


  const deviationId = localStorage.getItem(this.ACTIVE_DEVIATION_ID);
  if (!deviationId) {
    this.handleFailure();
    return;
  }
  this.spinner.start();
  this.deviationService.closeDeviation(deviationId)
    .subscribe({
      next: (res:any) => {

      if (res.error) {
        this.handleFailure(res); //backend message shown
        return;
      }
        this.spinner.stop();
        this.clearDeviationState();
        this.handleSuccess(res);
        this.dialogRef.close(true);
      },
      error: () => this.handleFailure()
    });

}


  // Step change hook
  onStepChange(event: StepperSelectionEvent) {

    if (event.selectedIndex === 1) {
      this.loadRootCause = true;
    }

    if (event.selectedIndex === 2) {
      this.loadCapa = true;
    }
  }
  back() {
    this.stepper.previous();
  }


  cancel() {
    this.dialogRef.close(true);
    this.rootCauses = [];
    this.capas = [];
    this.clearDeviationState();
  }

  loadDeviationForEdit(deviationId: any): void {
  this.spinner.start();

  this.deviationService.getDeviationById(deviationId).subscribe({
    next: (response: any) => {
      this.spinner.stop();

      if (!response) {
        this.handleInvalidDeviation();
        return;
      }

      this.addDeviationData(response);
    },
    error: () => {
      this.spinner.stop();
      this.handleInvalidDeviation();
    }
  });

 }



addDeviationData(response: any) {

  this.deviationForm.patchValue({
    deviationObjectType: response.deviationObjectType,
    deviationDetails: response.deviationDetails
  });

  this.rootCauses = response.rootCauses || [];
  this.capas = response.capas || [];
}


  resetState() {
    this.deviationForm.reset();
    this.rootCauses = [];
    this.capas = [];
    this.stepIndex = 0;
    this.deviationId = null;
  }


  handleInvalidDeviation(): void {
  this.snackBar.open(
    "Deviation data could not be loaded. Edit is not allowed.",
    "OK",
    { duration: 4000 }
  );

  this.dialogRef.close(false);
}

private handleFailure(res?: any): void {
  this.spinner.stop();

  const message =
    res?.statusMessage ||
    'Operation failed. Please try again.';

  this.snackBar.open(message, 'Ok', {
    duration: 4000
  });

  this.clearDeviationState();
  this.dialogRef.close();
}

clearDeviationState() {
  localStorage.removeItem(this.ACTIVE_DEVIATION_ID);
  this.rootCauses = [];
  this.capas = [];
  this.deviationForm.reset();
  this.deviationId = null;
  this.headerContext = [];
  this.productName = null;
  this.productId = null;
}
private handleSuccess(res: any): void {
  if (res && res.error === false) {
    this.snackBar.open(res.statusMessage, 'Ok', {
      duration: 3000
    });
  }
}

public mandatoryRules: MandatoryRule[] = [
  {
    control: () => this.deviationForm.get('deviationDetails.correctiveAction'),
    label: 'Corrective Action Taken',
    when: () => this.deviationForm.get('deviationDetails.capaRequired')?.value,
    controlName: 'correctiveAction'
  },
  {
    control: () => this.deviationForm.get('deviationDetails.investigationAndSummaryConclusion'),
    label: 'Investigation & Summary Conclusion',
    // when: () =>  this.deviationForm.get('deviationDetails.furtherInvestigationRequired')?.value,
    controlName:'investigationAndSummaryConclusion'
  },
  {
  label: 'Add At least one CAPA record',
  when: () =>
    this.deviationForm.get('deviationDetails.capaRequired')?.value === true,
  customCheck: () => this.hasValidCapa,

}

];

private validateMandatoryRules(): boolean {
  const missingFields: string[] = [];
  

  this.mandatoryRules.forEach(rule => {
    if (rule.when && !rule.when()) {
      return;
    }

      // 🔹 Non-form validation (CAPA etc.)
    if (rule.customCheck) {
      if (!rule.customCheck()) {
        missingFields.push(rule.label);
      }
      return;
    }

    const control = rule.control(); 
    const value = control?.value; // now always latest

    if (!value || value.toString().trim() === '') {
      control?.setErrors({ mandatory: true });
      control?.markAsTouched();
      control?.markAsDirty();
      missingFields.push(rule.label);
    } else {
      // clear old mandatory error if filled
      if (control?.hasError('mandatory')) {
        control.setErrors(null);
      }
    }
  });

  if (missingFields.length) {
    this.snackBar.open(
      `Please complete mandatory fields: ${missingFields.join(', ')}`,
      'OK',
      { duration: 5000 }
    );
    return false;
  }

  return true;
}

public getMandatoryError(controlName: string): string | null {
  const rule = this.mandatoryRules.find(r => r.controlName === controlName);
  const control = this.deviationForm.get('deviationDetails.' + controlName);
  if (rule && control?.hasError('mandatory')) {
    return rule.label + ' is mandatory.';
  }
  return null;
}


private validateHeaderContext(
  context: any
): context is HeaderContextItem[] {

  if (!Array.isArray(context)) {
    console.error('Header context is not an array');
    this.snackBar.open(
      'Header context is not an array.',
      'OK',
      { duration: 5000 }
    );
    return false;
  }

  const isValid = context.every(
    (item) =>
      item &&
      typeof item === 'object' &&
      typeof item.label === 'string' &&
      item.label.trim().length > 0 &&
      typeof item.value === 'string' &&
      item.value.trim().length > 0
  );

  if (!isValid) {
    console.error('Header context format is invalid', context);
    this.snackBar.open(
      'Header context format is invalid.',
      'OK',
      { duration: 5000 }
    );
  }

  return isValid;
}

private buildMetadataFromHeaderContext(): Record<string, string> {
  if (!this.validateHeaderContext(this.headerContext)) {
    throw new Error('Invalid header context');
  }

  return this.headerContext.reduce((acc, item) => {
    acc[item.label] = item.value;
    return acc;
  }, {} as Record<string, string>);
}



}
